import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    index:0,
    currentQuestion: {},
    choicesList:[
    ],
    tutorielsList:[
    ],
    isGameCompleted:false,
    resultat:{},
}
const gameZoneSlice = createSlice({
    name:'gameZone',
    initialState,
    reducers:{
        setCurrentQuestion:(state,{payload})=>{
            state.currentQuestion = payload
            state.index = state.index + 5
        },
        setChoicesList:(state,{payload})=>{
            state.choicesList = payload;
        },
        setTutorielsList:(state,{payload})=>{
            state.tutorielsList = payload
        },
        setIsGameCompleted:(state,{payload})=>{
            state.isGameCompleted = true
            state.resultat = payload
        },
        resetGame:(state,{payload})=>{
            state.isGameCompleted = false
            state.choicesList = []
            state.currentQuestion = {}
            state.index = 0
            state.resultat = {}
        },
    }
})

export const { setCurrentQuestion,setChoicesList,setIsGameCompleted ,resetGame,setCurrentStep} = gameZoneSlice.actions
export default gameZoneSlice.reducer